import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import "react-toastify/dist/ReactToastify.css";
import ls from "local-storage";
import Moment from "react-moment";
import "moment-timezone";
import * as CONFIG from "./_config";

toast.configure();

const axios = require("axios");

class Department extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coupanlist: [],
      department: [],
      dept: null,
      show: false,
      productdata: [],
      departmentinfo: null,
      dept1: [],
    };
  }

  componentDidMount() {
    this.Department();
    this.NewDepartment();
    ls.set("redirectTo", window.location.href);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.Coupanlist();
      this.NewDepartment();
      ls.set("redirectTo", window.location.href);
    }
  }

  Department() {
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    const data = new FormData();
    data.append("method", "POST");
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetCategoriesForCoupons`;
    data.append("ClientDbName", CONFIG.DATA.RSA_CLIENT_DB_NAME);
    data.append("ClientId", CONFIG.DATA.RSA_CLIENT_ID);
    data.append("Token", "");

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: "clientsupport" },
      })
      .then((res) => {
        console.log(res);
        if (res.data !== null) {
          console.log(res.data);
          this.setState({ departments: res.data.Categories, dept: "" });
          this.Coupanlist();
        } else {
          this.setState({ departments: [], dept: "", coupanlist: [] });
        }
      })
      .catch(function (response) {
        console.log(response);
      });
  }
  NewDepartment() {
    var url = this.props.match.params.id;

    var dept_info = CONFIG.DATA.DEPARTMENTS || [];
    var departmentinfo = null;
    var departmentinfo = dept_info.find(({ slug }) => slug === url);
    console.log(dept_info);
    this.setState({
      departmentinfo: departmentinfo,
    });
  }

  Coupanlist() {
    this.setState({ coupanlist: null });
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;
    let DepartmentID = 0;
    //console.log(this.props)
    let dept_name = this.props.match.params.id || "";
    //console.log(dept_name) //not null
    let dept = null;
    console.log(this.state.department);
    if (dept_name !== "" && this.state.department) {
      dept = this.state.departments.find(
        (d) =>
          d.DepartmentName.replace(/\s/g, "-")
            .replace(/\//g, "_")
            .toLowerCase() === dept_name
      );
      if (dept) {
        this.setState({ dept: dept, coupanlist: [] });
        DepartmentID = dept.DepartmentID;
      }
    }
    console.log(this.state);
    // Rob asked to remove "Related coupons" on 2021-02-10

    // const data = new FormData();
    // data.append('method', 'POST');
    // data.append('apiurl', `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetDetailsForCoupons/${DepartmentID}/${UserToken}/0`);

    // axios.post(CONFIG.API_ROOT, data)
    //   .then((res) => {
    //       if(DepartmentID > 0) {
    //           this.setState({coupanlist: res.data.Specials, DepartmentID: DepartmentID});
    //       }
    //   })
    //   .catch(function (response) {
    //       console.log(response);
    //   });
  }

  AddtoCart = async (event, index) => {
    event.preventDefault();
    event.persist();

    if (!ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)) {
      toast.info("Please login to add item to cart!");
      // ls.set('redirectTo', this.props.history.location.pathname);
      ls.set("redirectTo", window.location.href);
      this.props.history.push("/login");
      return false;
    }

    var button_span = null;
    if (event.target && event.target.tagName.toLowerCase() === "span") {
      button_span = document.getElementById(event.target.id);
    } else if (
      event.target &&
      event.target.tagName.toLowerCase() === "button"
    ) {
      var button = document.getElementById(
        event.target.id
      ); /* id is unique by definition! */
      var spans = button.getElementsByTagName("span");
      if (spans) button_span = spans[0];
    }

    if (button_span === null) {
      return false;
    }

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : CONFIG.DATA.GUEST_TOKEN_USER;

    if (index !== null && index > -1) {
      // var product = JSON.parse(details,true)
      var coupanlist = this.state.coupanlist;
      var product = coupanlist[index];

      this.setState({ show: false });

      const data = new FormData();

      if (product) {
        if (button_span.getAttribute("data-action") !== "remove") {
          //if (!product.IsInCart) {

          data.append("method", "POST");
          const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/SaveMyCart`;

          data.append(
            "OfferId",
            product.SSNewsId ? product.SSNewsId : product.SSNewsId
          );
          data.append("CategoryId", product.NewsCategoryId);
          data.append(
            "MemberNumber",
            ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).MemberNumber
          );
          data.append("UserFirstName", product.CustomerName);
          data.append("NCRPromotionCode", product.NCRPromotionCode);
          data.append("IsInNCRImpressions", product.IsInNCRImpressions);
          data.append("Title", product.Title);
          data.append("Details", product.Details);
          data.append("Amount", product.Amount);
          data.append("ProductName", product.ProductName);
          data.append("ValidFrom", product.ValidFromDate);
          data.append("ExpiresOn", product.ExpiresOn);
          data.append("UPC", "");
          data.append("UserToken", UserToken);

          var object = {};
          data.forEach((value, key) => (object[key] = value));
          var jsonData = JSON.stringify(object);

          axios
            .post(apiurl, jsonData, {
              headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
            })
            .then((res) => {
              if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorCode !== null &&
                res.data.ErrorMessage.ErrorCode === 1
              ) {
                product.IsInCart = true;

                var button_span = null;
                if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "span"
                ) {
                  button_span = document.getElementById(event.target.id);
                } else if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "button"
                ) {
                  var button = document.getElementById(
                    event.target.id
                  ); /* id is unique by definition! */
                  var spans = button.getElementsByTagName("span");
                  if (spans) button_span = spans[0];
                }

                if (button_span !== null) {
                  button_span.innerHTML = CONFIG.DATA.REMOVE_FROM_CART_TEXT;
                  button_span.setAttribute("data-action", "remove");

                  document.getElementById(
                    "add_to_cart_shape_" + index
                  ).style.display = "block";
                }
                toast.info("Item added to cart.", { autoClose: 2000 });
                this.Notification("plus");
              } else if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorDetails !== null
              ) {
                toast.info(res.data.ErrorMessage.ErrorDetails, {
                  autoClose: 2000,
                });
              }
            })
            .catch(function (response) {
              console.log(response);
            });
        } else {
          data.append("method", "POST");

          const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/RemoveFromCart/${product.SSNewsId}/${UserToken}`;

          var object = {};
          data.forEach((value, key) => (object[key] = value));
          var jsonData = JSON.stringify(object);

          axios
            .post(apiurl, jsonData, {
              headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
            })
            .then((res) => {
              if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorCode !== null &&
                res.data.ErrorMessage.ErrorCode === 1
              ) {
                // console.log('resresres210', res);
                product.IsInCart = false;

                var button_span = null;
                if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "span"
                ) {
                  button_span = document.getElementById(event.target.id);
                } else if (
                  event.target &&
                  event.target.tagName.toLowerCase() === "button"
                ) {
                  var button = document.getElementById(
                    event.target.id
                  ); /* id is unique by definition! */
                  var spans = button.getElementsByTagName("span");
                  if (spans) button_span = spans[0];
                }

                if (button_span !== null) {
                  button_span.innerHTML = CONFIG.DATA.ADD_TO_CART_TEXT;
                  button_span.setAttribute("data-action", "add");

                  document.getElementById(
                    "add_to_cart_shape_" + index
                  ).style.display = "none";
                }

                toast.warn("Item removed from cart.", { autoClose: 2000 });
                this.Notification("minus");
              } else if (
                res &&
                res.data &&
                res.data.ErrorMessage &&
                res.data.ErrorMessage.ErrorDetails !== null
              ) {
                toast.warn(res.data.ErrorMessage.ErrorDetails, {
                  autoClose: 2000,
                });
              }
            })
            .catch(function (response) {
              console.log(response);
            });
        }
      }
    }
  };

  Notification(type) {
    var item_count = document
      .getElementById("Notificationcount")
      .getElementsByTagName("span")[0].innerHTML;
    if (type === "plus") {
      item_count++;
    } else {
      item_count--;
    }
    if (item_count !== null && !isNaN(item_count)) {
      item_count = item_count || 0;

      document.getElementById("Notificationcount").innerHTML =
        '<img src="/assets/images/icons/shopingcarticons.png"><span class="badge">' +
        item_count +
        "</span>";
      document.getElementById("tip-cart").innerHTML =
        item_count > 0
          ? "Click to view your shopping cart"
          : "You have no items in your shopping cart";
    }
  }

  handleClose = () => {
    this.setState({ show: false });
  };

  handleShow = (e, index) => {
    e.preventDefault();
    this.setState({ show: true });
    this.setState({ product_index: index });
    setTimeout(() => {
      // console.log(this.state);
    }, 100);
  };

  render() {
    let dept1 = this.state.dept;

    //console.log(this.state.dept)

    //console.log(dept1.length)

    if (dept1 === null && this.state.departmentinfo === null)
      return (
        <React.Fragment>
          <div style={{ textAlign: "left", minHeight: "600px" }}>
            <div className="content">
              <div className="overlay">
                <div className="overlay-content">
                  <img
                    style={{ maxWidth: "none" }}
                    src="/assets/images/loading.gif"
                    alt="Loading..."
                  />
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </React.Fragment>
      );

    var index = this.state.product_index;
    var productdata =
      index !== null && index > -1 ? this.state.coupanlist[index] : null;
    const coupanlist =
      this.state.coupanlist &&
      this.state.coupanlist.map((value, index) => {
        var productInCart = value.IsInCart;
        var productDetails = value.Details;
        var productNewsCategoeyId = value.NewsCategoryId;

        var productTitle = value.Title;
        if (productNewsCategoeyId === 4) {
          productTitle = value.ProductName;
        }
        var productTitleShow = productTitle;
        if (productTitle != null && productTitle.length > 35) {
          productTitleShow = productTitle.substring(0, 35) + "...";
        }

        var cartTitle = CONFIG.DATA.ADD_TO_CART_TEXT;
        if (productInCart === true) {
          cartTitle = CONFIG.DATA.REMOVE_FROM_CART_TEXT;
        }

        return (
          <div
            key={index}
            className="department-coupons item-col col-md-3 col-full-hd product type-product status-publish has-post-thumbnail product_cat-dress product_cat-drink product_cat-fashion first instock sale shipping-taxable purchasable product-type-simple"
            style={{ minWidth: "292px" }}
          >
            <div className="product-wrapper">
              <div className="gridview">
                <div className="list-col4 ">
                  <div className="red-corner">{/*<!-- -->*/}</div>
                  <div className="free">
                    Save{" "}
                    <span style={{ fontSize: "15px", display: "block" }}>
                      {value.PLUCode}
                    </span>
                  </div>

                  <div
                    id={`add_to_cart_shape_${index}`}
                    className="add_to_cart_shape"
                    style={{ display: productInCart ? "block" : "none" }}
                  >
                    <img
                      loading="lazy"
                      alt="already in cart"
                      src="/assets/images/shape_1.png"
                    />
                  </div>
                  <div className="product-image">
                    <Link
                      to="#"
                      className="woocommerce-LoopProduct-link woocommerce-loop-product__link"
                    >
                      <div
                        style={{
                          width: "65%",
                          margin: "0 auto",
                          height: "150px",
                        }}
                      >
                        <img
                          loading="lazy"
                          width="300"
                          height="300"
                          src={value.ImagePath}
                          className="primary_image"
                          alt="Department"
                          style={{ height: "100%", objectFit: "contain" }}
                        />
                      </div>
                    </Link>
                  </div>
                  <div className="quickviewbtn" style={{ zIndex: "99" }}>
                    <Link
                      to="#"
                      onClick={(e) => {
                        this.handleShow(e, index);
                      }}
                      className="quickview1"
                      href="#"
                      title="Vestibulum suscipit"
                    >
                      Quick View
                    </Link>
                  </div>
                </div>
                <div className="list-col8 ">
                  {/*<h2 className="product-name">
                            <a style={{color:'red', fontWeight:'bold'}} href="#">SAVE {value.PLUCode}</a>
                          </h2>*/}
                  <h4 className="product-name">
                    <Link to="#">{productTitleShow}</Link>
                  </h4>
                  <div className="ratings"></div>
                  <div className="price-box">
                    <div className="product-name product-desc" style={{}}>
                      {productDetails}
                    </div>
                  </div>
                  <ul className="actions">
                    <li className="add-to-cart">
                      <button
                        onClick={(e) => {
                          this.AddtoCart(e, index);
                        }}
                        rel="nofollow"
                        id={`add_to_cart_${index}`}
                        className="quickview btn btn-theme add_to_cart"
                      >
                        <span
                          id={`span_add_to_cart_${index}`}
                          data-action={productInCart ? "remove" : "add"}
                          className="title-cart"
                        >
                          {cartTitle}
                        </span>
                      </button>
                    </li>
                  </ul>
                  <div className="count-down">
                    <div className="countbox hastime" data-time="2020/01/23">
                      <span className="timebox day">
                        146<strong>days</strong>
                      </span>
                      <span className="timebox hour">
                        11<strong>hours</strong>
                      </span>
                      <span className="timebox minute">
                        41<strong>mins</strong>
                      </span>
                      <span className="timebox second">
                        16<strong>secs</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        );
      });

    return (
      <div>
        <div className="main-container default-page">
          <div className="dsd">
            {dept1 !== null && this.state.departmentinfo == null ? (
              <div className="pt-2 mt-2">
                {CONFIG.DATA.THEME === 2 ? (
                  <section
                    id="apus-breadscrumb"
                    className="breadcrumb-page apus-breadscrumb"
                    style={{ backgroundColor: "#f3ffd9" }}
                  >
                    <div className="container">
                      <div className="wrapper-breads">
                        <div className="wrapper-breads-inner">
                          <div className="breadscrumb-inner">
                            <h2 className="bread-title">
                              {dept1.DepartmentName}
                            </h2>
                            <ol className="breadcrumb">
                              <li>
                                <a href="/">Home</a>
                              </li>
                              <li>
                                <span className="active">
                                  {dept1.DepartmentName}
                                </span>
                              </li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                ) : (
                  <div className="title-breadcrumb">
                    <div className="container">
                      <header className="entry-header">
                        <h1 className="entry-title">{dept1.DepartmentName}</h1>
                      </header>
                      <div className="breadcrumbs d-none d-md-block">
                        <a href="/">Home</a>
                        <span className="separator">/</span>
                        <a href={"/" + dept1.DepartmentName}>
                          {dept1.DepartmentName}
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : this.state.departmentinfo != null ? (
              <div className="pt-5 mt-5">
                {CONFIG.DATA.THEME === 2 ? (
                  <section
                    id="apus-breadscrumb"
                    className="breadcrumb-page apus-breadscrumb"
                    style={{ backgroundColor: "#f3ffd9" }}
                  >
                    <div className="container">
                      <div className="wrapper-breads">
                        <div className="wrapper-breads-inner">
                          <div className="breadscrumb-inner">
                            <h2 className="bread-title">Department</h2>
                            <ol className="breadcrumb">
                              <li>
                                <a href="/">Home</a>
                              </li>
                              <li>
                                <span className="active">
                                  {this.state.departmentinfo.departmentname}
                                </span>
                              </li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                ) : (
                  <div className="title-breadcrumb">
                    <div className="container">
                      <header className="entry-header">
                        <h1 className="entry-title">
                          {this.state.departmentinfo.departmentname}
                        </h1>
                      </header>
                      <div className="breadcrumbs d-none d-md-block">
                        <a href="/">Home</a>
                        <span className="separator">/</span>
                        <a href={"/" + this.state.departmentinfo.slug}>
                          {this.state.departmentinfo.departmentname}
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              " "
            )}

            <div>
              <div className="container">
                {this.state.dept != null &&
                this.state.departmentinfo == null ? (
                  <div
                    className="main-container default-page mt-5"
                    style={{ textAlign: "left", minHeight: "550px" }}
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <img
                          alt="Department"
                          loading="lazy"
                          style={{
                            height: "300px",
                            maxWidth: "none",
                            width: "520px",
                          }}
                          src={dept1.WebDepartmentImageName}
                        />
                      </div>
                      <div
                        className="col-md-6 rev font-size-17px"
                        style={{ textAlign: "left" }}
                      >
                        {dept1.DepartmentDescription}
                        {/* 2021-05-27 Add hardcoded text and image for Mosers > Deli department */}
                        {CONFIG.DATA.BACKEND_HOST === "mosersfoods" &&
                        dept1 &&
                        dept1.DepartmentName &&
                        dept1.DepartmentName.toLowerCase() === "deli" ? (
                          <>
                            <div className="row pt-3">
                              <div className="col-md-12">
                                {/* <h2>We Offer Chester Chicken</h2> */}
                                <img
                                  alt="Chester Chiken"
                                  loading="lazy"
                                  style={{ width: "auto", maxWidth: "none" }}
                                  src={
                                    "/assets/images/moser_chester_chicken.png"
                                  }
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    {CONFIG.DATA.BACKEND_HOST == "okpricemart" &&
                    dept1 &&
                    dept1.DepartmentName &&
                    dept1.DepartmentName.toLowerCase() == "deli" ? (
                      <>
                        <div className="row pt-3">
                          <div className="col-md-12">
                            <h2>OK Price Mart – Tulsa Deli Offerings</h2>
                          </div>
                          <div className="col-md-12" style={{ color: "#000" }}>
                            <ul className="pl-5">
                              <li>Sliced Meat</li>
                              <li>Sliced Cheese</li>
                              <li>Rotisserie Chicken</li>
                              <li>St. Louis Style Ribs</li>
                            </ul>
                          </div>
                        </div>

                        <div className="row pt-3">
                          <div className="col-md-12">
                            <h2>OK Price Mart – Sapulpa Deli Offerings</h2>
                          </div>
                          <div className="col-md-12" style={{ color: "#000" }}>
                            <ul className="pl-5">
                              <li>Sliced Meat</li>
                              <li>Sliced Cheese</li>
                              <li>Fresh Deli Menu</li>
                            </ul>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 py-5">
                            <img
                              alt="Digital Menu"
                              loading="lazy"
                              style={{ width: "100%", maxWidth: "none" }}
                              src={"/assets/images/Docs_DigitalMenu_2020.jpg"}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div>
                      {productdata ? (
                        <Modal
                          show={this.state.show}
                          size="lg"
                          dialogClassName="modal-60w"
                          centered
                          onHide={this.handleClose}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>{productdata.ProductName}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="row">
                              <div className=" col-md-3">
                                <img
                                  alt="Department"
                                  loading="lazy"
                                  src={productdata.ImagePath}
                                />
                              </div>
                              <div className="col-md-9">
                                <h6
                                  style={{ color: "red", fontStyle: "italic" }}
                                >
                                  Offer Expires on{" "}
                                  <Moment unix format={"MM/DD/YYYY"}>
                                    {productdata.ExpiresOn
                                      ? productdata.ExpiresOn.replace("/", "")
                                          .replace("/", "")
                                          .replace("Date(", "")
                                          .replace(")", "")
                                          .replace("000+0000", "")
                                          .replace(" ", "")
                                      : ""}
                                  </Moment>
                                </h6>

                                <button
                                  onClick={(e) => {
                                    this.AddtoCart(e, index);
                                  }}
                                  rel="nofollow"
                                  id={`add_to_cart_${index}`}
                                  className="quickview btn btn-success add_to_cart"
                                >
                                  <span
                                    id={`span_add_to_cart_${index}`}
                                    data-action={
                                      productdata.IsInCart ? "remove" : "add"
                                    }
                                    className="title-cart"
                                  >
                                    {productdata.IsInCart
                                      ? CONFIG.DATA.REMOVE_FROM_CART_TEXT
                                      : CONFIG.DATA.ADD_TO_CART_TEXT}
                                  </span>
                                </button>
                                <hr />
                                <p>{productdata.Details}</p>
                              </div>
                            </div>
                          </Modal.Body>
                        </Modal>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : this.state.departmentinfo != null ? (
                  <div
                    className="main-container default-page mt-5"
                    style={{ textAlign: "left", minHeight: "550px" }}
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <img
                          alt="Department"
                          loading="lazy"
                          style={{
                            height: "300px",
                            maxWidth: "none",
                            width: "520px",
                          }}
                          src={this.state.departmentinfo.dept_image}
                        />
                      </div>
                      <div className="col-md-6" style={{ textAlign: "left" }}>
                        <p
                          style={{ fontSize: "14px" }}
                          dangerouslySetInnerHTML={{
                            __html: this.state.departmentinfo.description,
                          }}
                        ></p>

                        {/* 2021-05-27 Add hardcoded text and image for Mosers > Deli department */}
                        {CONFIG.DATA.BACKEND_HOST === "mosersfoods" &&
                        dept1 &&
                        dept1.DepartmentName &&
                        dept1.DepartmentName.toLowerCase() == "deli" ? (
                          <>
                            <div className="row pt-3 hidden">
                              <div className="col-md-12">
                                <h2>We Offer Chester Chicken</h2>
                                <img
                                  alt="Chester Chiken"
                                  loading="lazy"
                                  style={{ width: "auto", maxWidth: "none" }}
                                  src={"/assets/images/Chester.png"}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    {CONFIG.DATA.BACKEND_HOST == "okpricemart" &&
                    dept1 &&
                    dept1.DepartmentName &&
                    dept1.DepartmentName.toLowerCase() == "deli" ? (
                      <>
                        <div className="row pt-3">
                          <div className="col-md-12">
                            <h2>OK Price Mart – Tulsa Deli Offerings</h2>
                          </div>
                          <div className="col-md-12" style={{ color: "#000" }}>
                            <ul className="pl-5">
                              <li>Sliced Meat</li>
                              <li>Sliced Cheese</li>
                              <li>Rotisserie Chicken</li>
                              <li>St. Louis Style Ribs</li>
                            </ul>
                          </div>
                        </div>

                        <div className="row pt-3">
                          <div className="col-md-12">
                            <h2>OK Price Mart – Sapulpa Deli Offerings</h2>
                          </div>
                          <div className="col-md-12" style={{ color: "#000" }}>
                            <ul className="pl-5">
                              <li>Sliced Meat</li>
                              <li>Sliced Cheese</li>
                              <li>Fresh Deli Menu</li>
                            </ul>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 py-5">
                            <img
                              alt="Digital Menu"
                              loading="lazy"
                              style={{ width: "100%", maxWidth: "none" }}
                              src={"/assets/images/Docs_DigitalMenu_2020.jpg"}
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div>
                      {productdata ? (
                        <Modal
                          show={this.state.show}
                          size="lg"
                          dialogClassName="modal-60w"
                          centered
                          onHide={this.handleClose}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>{productdata.ProductName}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="row">
                              <div className=" col-md-3">
                                <img
                                  alt="Department"
                                  loading="lazy"
                                  src={productdata.ImagePath}
                                />
                              </div>
                              <div className="col-md-9">
                                <h6
                                  style={{ color: "red", fontStyle: "italic" }}
                                >
                                  Offer Expires on{" "}
                                  <Moment unix format={"MM/DD/YYYY"}>
                                    {productdata.ExpiresOn
                                      ? productdata.ExpiresOn.replace("/", "")
                                          .replace("/", "")
                                          .replace("Date(", "")
                                          .replace(")", "")
                                          .replace("000+0000", "")
                                          .replace(" ", "")
                                      : ""}
                                  </Moment>
                                </h6>

                                <button
                                  onClick={(e) => {
                                    this.AddtoCart(e, index);
                                  }}
                                  rel="nofollow"
                                  id={`add_to_cart_${index}`}
                                  className="quickview btn btn-success add_to_cart"
                                >
                                  <span
                                    id={`span_add_to_cart_${index}`}
                                    data-action={
                                      productdata.IsInCart ? "remove" : "add"
                                    }
                                    className="title-cart"
                                  >
                                    {productdata.IsInCart
                                      ? CONFIG.DATA.REMOVE_FROM_CART_TEXT
                                      : CONFIG.DATA.ADD_TO_CART_TEXT}
                                  </span>
                                </button>
                                <hr />
                                <p>{productdata.Details}</p>
                              </div>
                            </div>
                          </Modal.Body>
                        </Modal>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Department);
